// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoaderSampleView_iconGrid__SWukp {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.LoaderSampleView_item__P5eZ0 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin: 20px;
}`, "",{"version":3,"sources":["webpack://./src/examples/views/LoaderSampleView/LoaderSampleView.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AACF","sourcesContent":[".iconGrid {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  margin: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconGrid": `LoaderSampleView_iconGrid__SWukp`,
	"item": `LoaderSampleView_item__P5eZ0`
};
export default ___CSS_LOADER_EXPORT___;
